import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import withSession from "../lib/session";
import { Container, Grid, Button } from "@mui/material";

import { PartnersList } from "../modules/Partners/List";
import prisma from "../lib/prisma";

export default function PartnersPage({ partners }) {
  //   console.log("partners", props.partners);
  return (
    <Layout>
      <Container>
        <PartnersList partners={partners} />
      </Container>
    </Layout>
  );
}

export const getServerSideProps = withSession(async function ({ req, res }) {
  const partners = await prisma.partners.findMany({ include: { Logo: true } });
  return {
    props: { partners: JSON.parse(JSON.stringify(partners)) },
  };
});
